/**
 * Soft pastel chip styles shared by the settings card and the calls-page
 * dropdown, so a tag / owner / AI badge looks the same everywhere it appears.
 * Deliberately low-saturation — these sit next to data and shouldn't shout.
 */
type PastelTone = { bg: string; fg: string };

const TONES: Record<"tag" | "owner" | "ai", PastelTone> = {
  tag: { bg: "#EDE7F6", fg: "#5E35B1" }, // lavender
  owner: { bg: "#E3F2FD", fg: "#1565C0" }, // sky
  ai: { bg: "#E8F5E9", fg: "#2E7D32" } // mint
};

export const pastelChipSx = (tone: keyof typeof TONES) => ({
  height: 20,
  fontSize: 11,
  fontWeight: 600,
  borderRadius: "6px",
  bgcolor: TONES[tone].bg,
  color: TONES[tone].fg,
  border: "none",
  "& .MuiChip-label": { px: 0.75 },
  "& .MuiChip-icon": { color: TONES[tone].fg, ml: 0.5, mr: -0.25, fontSize: 14 }
});
